import * as React from 'react';
import { translation } from '../../i18n';
import ErrorPage from './ErrorPage';

class NotFoundPage extends React.Component<{}> {

  public render() {
    return (
      <ErrorPage content={translation.t('errors.notFoundPage.content')}
                 headline={translation.t('errors.notFoundPage.headline')}
                 button={translation.t('errors.notFoundPage.button')}/>
    );
  }

}

export default NotFoundPage;
